import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class LanguageUrlInterceptor {
  constructor(private readonly router: Router) {
    const originalNavigate = this.router.navigate.bind(this.router);
    const originalNavigateByUrl = this.router.navigateByUrl.bind(this.router);

    this.router.navigate = (commands: any[], extras?: any) => {
      return originalNavigate(this.prefixLang(commands), extras);
    };

    this.router.navigateByUrl = (url: string | UrlTree, extras?: any) => {
      return originalNavigateByUrl(this.prefixLangUrl(url), extras);
    };
  }

  private prefixLang(commands: any[]) {
    const lang = localStorage.getItem('lang') || 'en';
    if (typeof commands[0] === 'string' && !commands[0].startsWith(`/${lang}`)) {
      commands[0] = `/${lang}${commands[0].startsWith('/') ? '' : '/'}${commands[0]}`;
    }
    return commands;
  }

  private prefixLangUrl(url: string | UrlTree) {
    const lang = localStorage.getItem('lang') || 'en';
    if (typeof url === 'string' && !url.startsWith(`/${lang}`)) {
      url = `/${lang}${url.startsWith('/') ? '' : '/'}${url}`;
    }
    return url;
  }
}
